;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('PublicCampaignController', PublicCampaignController)

  /* @ngInject */
  function PublicCampaignController (
    $scope,
    $state,
    $q,
    $sce,
    $timeout,
    $rootScope,
    ShareLinkService
  ) {
    $scope.loading = true
    $scope.templates = []
    $scope.collections = []
    $scope.templateOptions = {}
    $scope.templateParam = {}
    $scope.loadingMoreItems = false

    $scope.collectionsLimit = 10
    $scope.collectionsOffset = 0
    $scope.templatesLimit = 10
    $scope.templatesOffset = 0
    $scope.hasMoreCollections = true
    $scope.hasMoreTemplates = true
    $scope.collectionParentId = null
    $scope.selectedTemplates = []
    $scope.selectedCollections = []
    $scope.companyName = ''

    const api = {
      _successGetLinkInfo,
      _errorGetLinkInfo,
      _handleShiftClickOnTemplate,
      _handleShiftClickOnCollection,
      _unselectAllExceptFirstSelected,
      _getPreviewAssets
    }
    this.getApi = () => api

    activate()

    function activate () {
      $scope.uuid = $state.params.uuid
      ShareLinkService.getShareFolderlink({
        iUuid: $scope.uuid,
        collectionsLimit: $scope.collectionsLimit,
        collectionsOffset: $scope.collectionsOffset,
        templatesLimit: $scope.templatesLimit,
        templatesOffset: $scope.templatesOffset
      })
        .then(api._successGetLinkInfo)
        .catch(api._errorGetLinkInfo)
        .finally(() => {
          $scope.loading = false
        })
    }

    function _successGetLinkInfo (link) {
      $scope.link = link
      if ($scope.link.comment) {
        $scope.link.comment = $sce.trustAsHtml($scope.link.comment)
      }

      if ($scope.link.templates) {
        $scope.templates = $scope.link.templates
        $scope.hasMoreTemplates = $scope.link.templates.count > $scope.templates.rows.length
      }

      if ($scope.link.collections) {
        $scope.collections = $scope.link.collections
        $scope.hasMoreCollections = $scope.link.collections.count > $scope.collections.rows.length
      }

      if ($scope.link.collection) {
        $scope.collectionName = $scope.link.collection.title
      }
    }

    function _errorGetLinkInfo ({ data }) {
      if (data.code === 'EXPIRED') {
        $scope.companyName = data.data.customerCompanyName
        $scope.isExpired = true
        $scope.link = {
          art: {
            name: data.data.artName
          }
        }
      }
    }

    function _unselectAllExceptFirstSelected () {
      const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
      const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)

      if (!firstSelectedTemplate && !firstSelectedCollection) {
        return
      }

      $scope.selectedTemplates.concat($scope.selectedCollections).forEach(item => {
        item.selected = false
        item.firstSelection = false
      })

      if (firstSelectedTemplate) {
        firstSelectedTemplate.selected = true
        firstSelectedTemplate.firstSelection = true
        $scope.selectedTemplates = [firstSelectedTemplate]
        $scope.selectedCollections = []
      } else {
        firstSelectedCollection.selected = true
        firstSelectedCollection.firstSelection = true
        $scope.selectedTemplates = []
        $scope.selectedCollections = [firstSelectedCollection]
      }
    }

    function _handleShiftClickOnTemplate (template) {
      document.getSelection().removeAllRanges()
      api._unselectAllExceptFirstSelected()

      const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
      const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)
      let sectionTemplates = []
      let sectionCollections = []

      if ($scope.search.state.searching) {
        sectionTemplates = $scope.search.templates || []
        sectionCollections = $scope.search.collections || []
      } else {
        sectionTemplates = $scope.collectionData.templates || []
        sectionCollections = $scope.collectionData.collections || []
      }

      const indexOfClickedTemplate = sectionTemplates.indexOf(template)

      if (firstSelectedTemplate) {
        const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
        const startIndex = Math.min(indexOfFirstSelectedTemplate, indexOfClickedTemplate)
        const endIndex = Math.max(indexOfFirstSelectedTemplate, indexOfClickedTemplate) + 1
        const templatesToSelect = sectionTemplates.slice(startIndex, endIndex)

        templatesToSelect.forEach(t => {
          t.selected = true
        })
        $scope.selectedTemplates = [...templatesToSelect]
      } else if (firstSelectedCollection) {
        const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
        const collectionsToSelect = sectionCollections.slice(indexOfFirstSelectedCollection, (sectionCollections.length))
        const templatesToSelect = sectionTemplates.slice(0, indexOfClickedTemplate + 1)

        collectionsToSelect.forEach(c => {
          c.selected = true
        })
        templatesToSelect.forEach(t => {
          t.selected = true
        })

        $scope.selectedCollections = [...collectionsToSelect]
        $scope.selectedTemplates = [...templatesToSelect]
      }
    }

    function _handleShiftClickOnCollection (collection) {
      document.getSelection().removeAllRanges()
      api._unselectAllExceptFirstSelected()

      const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
      const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)
      let sectionTemplates = []
      let sectionCollections = []

      if ($scope.search.state.searching) {
        sectionTemplates = $scope.search.templates || []
        sectionCollections = $scope.search.collections || []
      } else {
        sectionTemplates = $scope.collectionData.templates || []
        sectionCollections = $scope.collectionData.collections || []
      }

      const indexOfClickedCollection = sectionCollections.indexOf(collection)

      if (firstSelectedCollection) {
        const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
        const startIndex = Math.min(indexOfFirstSelectedCollection, indexOfClickedCollection)
        const endIndex = Math.max(indexOfFirstSelectedCollection, indexOfClickedCollection) + 1
        const collectionsToSelect = sectionCollections.slice(startIndex, endIndex)

        collectionsToSelect.forEach(c => {
          c.selected = true
        })
        $scope.selectedCollections = [...collectionsToSelect]
      } else if (firstSelectedTemplate) {
        const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
        const templatesToSelect = sectionTemplates.slice(0, indexOfFirstSelectedTemplate + 1)
        const collectionsToSelect = sectionCollections.slice(indexOfClickedCollection, (sectionCollections.length))

        collectionsToSelect.forEach(c => {
          c.selected = true
        })
        templatesToSelect.forEach(t => {
          t.selected = true
        })

        $scope.selectedCollections = [...collectionsToSelect]
        $scope.selectedTemplates = [...templatesToSelect]
      }
    }

    $scope.handleDownloadSelectedTemplatesAndCollections = function () {
      const collectionIds = $scope.selectedCollections.map(c => c.id)
      const templateIds = $scope.selectedTemplates.map(t => t.id)

      ShareLinkService.downloadMultipleArts($scope.uuid, templateIds, collectionIds)
    }

    $scope.downloadAll = function () {
      ShareLinkService.downloadMultipleArts($scope.uuid, [], [$scope.link.collectionId])
    }

    $scope.isPreviewEnabled = function () {
      return false
    }

    function _getPreviewAssets () {
      const deferred = $q.defer()
      $timeout(() => {
        deferred.resolve({
          assets: $scope.templates,
          count: $scope.templates.length
        })
      }, 100, true)
      return deferred.promise
    }

    $scope.onTemplateClick = function (template, event) {
      const isShiftPressed = event && event.shiftKey
      if (template.selected) {
        template.firstSelection = false
        template.selected = false
        $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
      } else {
        if ($scope.selectedTemplates.length === 0 && $scope.selectedCollections.length === 0) {
          template.firstSelection = true
        }

        if (isShiftPressed) {
          return api._handleShiftClickOnTemplate(template)
        }

        template.selected = true
        $scope.selectedTemplates.push(template)
      }
    }

    $scope.onCollectionClick = function (collection, event) {
      const isShiftPressed = event && event.shiftKey
      if (collection.selected) {
        collection.firstSelection = false
        collection.selected = false
        $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
      } else {
        if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
          collection.firstSelection = true
        }

        if (isShiftPressed) {
          return api._handleShiftClickOnCollection(collection)
        }

        collection.selected = true
        $scope.selectedCollections.push(collection)
      }
    }

    $scope.onCollectionDoubleClick = function (subcollectionId) {
      $scope.loadingMoreItems = true

      ShareLinkService.getShareFolderlink({ iUuid: $scope.uuid, subcollectionId })
        .then((data) => {
          $scope.templates = data.templates
          $scope.collections = data.collections

          if (data.collection) {
            $scope.collectionName = data.collection.title
          }

          $scope.collectionParentId = subcollectionId === $scope.link.collectionId ? null : data.collection.parentId
          $scope.selectedTemplates = []
          $scope.selectedCollections = []
        })
        .catch(api._errorGetLinkInfo)
        .finally(() => {
          $scope.loadingMoreItems = false
        })
    }

    $scope.showMoreItems = function () {
      if ($scope.loadingMoreItemsPagination) return

      $scope.loadingMoreItemsPagination = true

      const loadMoreTemplates = $scope.hasMoreTemplates
      const loadMoreCollections = $scope.hasMoreCollections

      const params = { iUuid: $scope.uuid }

      if (loadMoreTemplates) {
        $scope.templatesOffset += $scope.templatesLimit
        params.templatesLimit = $scope.templatesLimit
        params.templatesOffset = $scope.templatesOffset
      }

      if (loadMoreCollections) {
        $scope.collectionsOffset += $scope.collectionsLimit
        params.collectionsLimit = $scope.collectionsLimit
        params.collectionsOffset = $scope.collectionsOffset
      }

      ShareLinkService.getShareFolderlink(params)
        .then((data) => {
          if (data.templates && data.templates.count) {
            $scope.templates.rows.push(...data.templates.rows)
            $scope.hasMoreTemplates = data.templates.count > $scope.templates.rows.length
          } else {
            $scope.hasMoreTemplates = false
          }

          if (data.collections && data.collections.count) {
            $scope.collections.rows.push(...data.collections.rows)
            $scope.hasMoreCollections = data.collections.count > $scope.collections.rows.length
          } else {
            $scope.hasMoreCollections = false
          }
        })
        .catch(api._errorGetLinkInfo)
        .finally(() => {
          $scope.loadingMoreItemsPagination = false
        })
    }

    $scope.hasMoreItems = function () {
      return $scope.hasMoreTemplates || $scope.hasMoreCollections
    }

    $scope.reloadPage = function () {
      $scope.loading = true
      $scope.selectedTemplates = []
      $scope.selectedCollections = []
      activate()
    }

    $scope.$on('public-campaign.remove-selected-items', () => {
      $scope.templates.rows.forEach(t => { t.selected = false })
      $scope.collections.rows.forEach(c => { c.selected = false })
      $scope.selectedTemplates = []
      $scope.selectedCollections = []
    })
  }
})()
